/* eslint-disable max-len */
/* istanbul ignore file */

export default {
    app_id: "SurveyApp",
    language: "English",
    localisation_strings: {
        RETRY: "Retry",
        CANCEL: "Cancel",
        RETRY_TEXT: "Oops! Something went wrong. Please try again later",
        NEXT: "NEXT",
        LANGUAGE_TITLE: "Select your language",
        DONE: "Done",
        SUBMIT: "Submit",
        GET_IT: "Get it",
        SUBMIT: "Submit",
        BACK_ARROW: "back-arrow",
        YES: "Yes",
        NO: "No",
        EXPIRED_QUIZ_MSG: "We're sorry, but it appears that the quiz you are trying to access has expired.",
        HEALTH_TALK_MESSAGE: `Thank you for showing interest for Health Talks by JioHealthHub!

        The venue has limited seating capacity.
        
        Please make sure you arrive early to grab your seat.
        
        See you at the venue!`,
        ERROR_MSG: "We are unable to proceed with your current request, Please try again later",
        DISCLAIMER: "Disclaimer",
        DISCLAIMER_ACTION_CLOSE: "Close",
        DISCLAIMER_ACTION_CONTINUE: "Continue",
        DISCLAIMER_CHECK_BOX: "I have read and agree to the above content.",
        HOME: "Home",
        QUESTIONNAIRE_ACTION_NEXT: "Next",
        QUESTIONNAIRE_ACTION_SKIP: "Skip",
        REFERENCE: "Reference",
        START_AGAIN: "Start again",
        VALID_RESPONSE: "Please provide a valid response.",
        VALID_PHONE_NO_RESPONSE: "Please provide a valid phone number.",
        VALID_EMAIL_ID_RESPONSE: "Please provide a valid email id",
        EmWise_SUB_TITLE: "Help us understand your needs better and win prizes",
        EmWise_TITLE: "EmWISE 1",
        WOMENSDAY_QUIZ: "Women's Day Quiz",
        EmWise_ELIGIBILITY: "Women Only",
        EmWise_ADDITIONAL_INFO: "20 Questions",
        EmWise_ADDITIONAL_INFO_1: "2 mins to complete.",
        EmWise_ACTION: "Take Survey",
        SURVEY_MAIN_TITLE: "Women’s Health Survey",
        SLEEPDAY_QUIZ: "Sleep Day Quiz",
        EXIT: "Exit",
        TAKE_FOR_FAMILY_MEMBER: "Take for family member",
        THANK_YOU: "Thank You",
        Congratulations: "Congratulations",
        THANK_YOU_SUB_TEXT:
            "Thanks for taking this one-minute survey. Your data is safe with us, and will only be used to provide the coupons for the lucky users.",
        WALKATHON_MESSAGE: "You have successfully registered for the World Health Day Walkathon at RCP Mumbai",
        CHOOSE_YOUR_REWARD: "Choose your reward",
        JIO_COUPONS: "Coupons",
        EmWise_MALE_DISCLAIMER:
            "This survey is especially designed for Women. However, you can take the survey for a female family member.",
        DISCLAIMER_MKT:
            "This Survey enables us to harness the best of available wisdom – from food to pharmacy to AYUSH - to create health, wellness, and beauty products that help people cultivate healthier lifestyles. ",
        DISCLAIMER_MKT_1:
            "The survey is intended to understand the needs of women and is designed for Women users. However male or female members can take this survey on behalf of their female family members.",
        DISCLAIMER_MKT_2:
            "Participants who complete the survey with all valid entries can select either a free online doctor consultation with Doctor or JioCoupons. The number of free online doctor consultations is limited to 1 per user.",
        DISCLAIMER_MKT_3:
            "JioHealthHub is only the facilitator of online doctor consultation. Scheduling and completion of the consult is subject to participant and doctor availability.",
        DISCLAIMER_MKT_4: "Jiocoupons will be provided subject to availability of Offers.",
        DISCLAIMER_MKT_5:
            "JioHealthHub can change the prize type, number of prizes, and terms and conditions without any prior intimation as the JioHealthHub is not liable to provide the prize. The participant should fill in the survey of his/her own will, without any entitlement to a prize.",
    },
};
